import { createApp } from 'vue'
import { createStore } from 'vuex'
import {
  createBootstrap, BAlert, BButton, BButtonGroup, BDropdown, BDropdownItem, BFormSelect, BModal, BPopover, BToast,
  BTooltip
} from 'bootstrap-vue-next'
import App from './App.vue'
import router from './router'

import '@/assets/css/bootstrap.scss'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import i18n from './i18n'
import ApplicationStore from './store'
import bootstrapVueCompat from './plugins/bootstrap-vue-compat'

const app = createApp(App)

app.use(createStore(ApplicationStore))
app.use(router)
app.use(i18n)
// vue-i18n 8 formatted whatever it was given (Intl.NumberFormat coerces the API's string columns such as
// time_nearest_station); vue-i18n 9+ returns '' for anything that is not a number.
const { n } = i18n.global
app.config.globalProperties.$n = (value, ...args) => n(Number(value), ...args)
// Defaults that keep bootstrap-vue's markup: dropdowns wrapped in an inline btn-group (the table action menus
// rely on it to stay on one line) and tooltips rendered in <body> rather than inside their target link.
app.use(createBootstrap({
  components: {
    BDropdown: { wrapperClass: 'btn-group b-dropdown dropdown' },
    BTooltip: { teleportTo: 'body' }
  }
}))
app.use(bootstrapVueCompat)

Object.entries({ BAlert, BButton, BButtonGroup, BDropdown, BDropdownItem, BFormSelect, BModal, BPopover, BToast, BTooltip })
  .forEach(([name, component]) => app.component(name, component))

app.mount('#app')
